"use strict";

exports.__esModule = true;
exports["default"] = Eye;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Eye(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M172.028 127.337l-70.846-42.3 2.457-4.114 70.846 42.3-2.457 4.114zm111.48 130.899c0-15.228-12.335-27.508-27.508-27.508-15.229 0-27.508 12.28-27.508 27.508 0 15.175 12.28 27.51 27.508 27.51 15.173 0 27.508-12.335 27.508-27.51m227.492-2.4L318.822 369.255v-.056c-17.629 9.716-37.935 15.283-59.438 15.445-1.146 0-2.292-.108-3.384-.108-1.146 0-2.237.108-3.384.108-21.504-.162-41.753-5.729-59.438-15.445v.056L1 255.836l194.306-109.707v.054c17.794-9.333 38.152-14.573 59.71-14.354.328 0 .709.054.982.054.328 0 .709-.054.982-.054 21.612-.219 41.862 5.021 59.711 14.354v-.054L511 255.836zm-163.086 2.4c0-50.758-41.154-91.967-91.914-91.967s-91.968 41.209-91.968 91.967c0 50.762 41.208 91.914 91.968 91.914s91.914-41.152 91.914-91.914zM258.777 15.354h-4.791v91.641h4.791V15.354z",
    fill: "#190101"
  }));
}